import styled from "styled-components";
import css from "@styled-system/css";
import { variant, color, layout, typography, space } from "styled-system";

import variants from "./variants";
import { TypographyProps } from "./typography.type";

const StyledTypographyComponent = styled.div<Partial<TypographyProps>>`
  box-sizing: border-box;
  overflow: hidden;
  ${css({
    fontFamily: "normal",
  })}
  ${variant({
    variants,
  })}
  ${color}
  ${layout}
  ${typography}
  ${space}
  ${(props) => props.css}
`;

const defaultVariantMapping = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  "body-small": "p",
  body: "p",
  "body-medium": "p",
  "body-medium-14": "p",
  "body-large": "p",
  // deprecated
  "body-lg": "p",
  caption: "p",
  label: "span",
};

export default function Typography({
  children,
  color,
  textAlign = "left",
  variant = "body",
  htmlTag,
  ...props
}: TypographyProps) {
  return (
    <StyledTypographyComponent
      textAlign={textAlign}
      variant={variant}
      as={htmlTag || defaultVariantMapping[variant]}
      color={color}
      {...props}
    >
      {children}
    </StyledTypographyComponent>
  );
}
